type Props = {
  height: string;
  stroke: string;
  width: string;
};
const PinIcon = ({ stroke, height, width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 10.5909C19 13.556 17.2058 16.4228 15.2501 18.6396C14.2888 19.7293 13.3246 20.6212 12.6001 21.2407C12.3733 21.4346 12.1708 21.6012 12 21.7382C11.8292 21.6012 11.6267 21.4346 11.3999 21.2407C10.6754 20.6212 9.71121 19.7293 8.74989 18.6396C6.79425 16.4228 5 13.556 5 10.5909C5 8.55559 5.75358 6.61671 7.07497 5.19771C8.39413 3.78112 10.1674 3 12 3C13.8326 3 15.6059 3.78112 16.925 5.19771C18.2464 6.61671 19 8.55559 19 10.5909Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PinIcon;
